module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-6.2803f42c.jpg";